var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWandWizard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 521.03 218.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient-17);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#linear-gradient-15);\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#linear-gradient-18);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#linear-gradient-14);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: url(#linear-gradient-20);\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: url(#linear-gradient-6);\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: url(#linear-gradient-11);\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: url(#linear-gradient-10);\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: url(#linear-gradient-16);\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: url(#linear-gradient-21);\r\n      }\r\n\r\n      .cls-12 {\r\n        fill: url(#linear-gradient-5);\r\n      }\r\n\r\n      .cls-13 {\r\n        fill: url(#linear-gradient-7);\r\n      }\r\n\r\n      .cls-14 {\r\n        fill: url(#linear-gradient-9);\r\n      }\r\n\r\n      .cls-15 {\r\n        fill: url(#linear-gradient-22);\r\n      }\r\n\r\n      .cls-16 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-17 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-18 {\r\n        fill: url(#linear-gradient-23);\r\n      }\r\n\r\n      .cls-19 {\r\n        fill: url(#linear-gradient-19);\r\n      }\r\n\r\n      .cls-20 {\r\n        fill: url(#linear-gradient-4);\r\n      }\r\n\r\n      .cls-21 {\r\n        fill: url(#linear-gradient-8);\r\n      }\r\n\r\n      .cls-22 {\r\n        fill: url(#linear-gradient-12);\r\n      }\r\n\r\n      .cls-23 {\r\n        fill: url(#linear-gradient-13);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -3468.06,
    y1: 1167.72,
    x2: -3412.7,
    y2: 1197.25,
    gradientTransform: "translate(2330.61 -2687.79) rotate(-70.5) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#513664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -4183.92,
    y1: -1133.33,
    x2: -4183.78,
    y2: -1158.96,
    gradientTransform: "translate(3987.97 -2172.51) rotate(-10.58) scale(1 -1.38) skewX(1.41)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#040505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -3998.76,
    y1: -1351.99,
    x2: -4420.12,
    y2: -1341.71,
    gradientTransform: "translate(4029.7 -1898.07) rotate(-9.99) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c4370c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#460f00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 88.59,
    y1: -83.92,
    x2: 116.33,
    y2: 243.96,
    gradientTransform: "translate(550.52 24.81) rotate(130.03)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#ffea00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff2300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 56.96,
    y1: -81.24,
    x2: 84.71,
    y2: 246.63,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 130,
    y1: -87.42,
    x2: 157.75,
    y2: 240.45,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 90.46,
    y1: -84.07,
    x2: 118.2,
    y2: 243.79,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 54.44,
    y1: -81.03,
    x2: 82.19,
    y2: 246.85,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 116.29,
    y1: -86.25,
    x2: 144.03,
    y2: 241.61,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 177.72,
    y1: -91.46,
    x2: 205.46,
    y2: 236.41,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 200.14,
    y1: -93.36,
    x2: 227.89,
    y2: 234.52,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 135.26,
    y1: -87.87,
    x2: 163.01,
    y2: 240.01,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 41.68,
    y1: -79.95,
    x2: 69.42,
    y2: 247.93,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 200.97,
    y1: -93.43,
    x2: 228.71,
    y2: 234.45,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 120.55,
    y1: -86.62,
    x2: 148.29,
    y2: 241.25,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 75.23,
    y1: -82.79,
    x2: 102.97,
    y2: 245.09,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 232.25,
    y1: -96.07,
    x2: 259.99,
    y2: 231.8,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 65.14,
    y1: -81.93,
    x2: 92.88,
    y2: 245.94,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 136.39,
    y1: -87.96,
    x2: 164.14,
    y2: 239.91,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 170.6,
    y1: -90.86,
    x2: 198.34,
    y2: 237.02,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 147.65,
    y1: -88.91,
    x2: 175.39,
    y2: 238.96,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 85.95,
    y1: -83.69,
    x2: 113.69,
    y2: 244.18,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 237.98,
    y1: -96.56,
    x2: 265.73,
    y2: 231.32,
    xlinkHref: "#linear-gradient-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "objects"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m138.98,175.69s-22.1-3.38-47.8.64c-47.23,7.37-65.62,39.78-74.49,41.9-4.48,1.07-12.31-10.75-15.44-31.05-3.12-20.3-.11-37.26,5.66-38.07,4.19-.59,31.98,15.73,76.29,10.04,27.3-3.51,50.81-22.11,50.81-22.11l4.97,38.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m145.24,154.9c-1.71-10.79-6.73-18.79-11.22-17.86-4.49.93-6.74,10.42-5.03,21.21,1.71,10.79,6.73,18.79,11.22,17.86,4.49-.93,6.74-10.42,5.03-21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m382.14,115.92l-240.33,48.25c-2.7.48-5.6-3.15-6.47-8.11-.87-4.95.61-9.35,3.31-9.83l242.61-35.32c1.37-.21,2.65.71,2.89,2.07.24,1.36-.65,2.66-2,2.93Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "wandStars"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m473.23,81.65c-.47-3.5-3.7-5.96-7.2-5.48-3.5.47-5.96,3.7-5.48,7.2.47,3.5,3.7,5.96,7.2,5.48,3.5-.47,5.96-3.7,5.48-7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m428.12,8.32c-.71-5.26-5.56-8.94-10.81-8.23-5.26.71-8.95,5.55-8.23,10.81.71,5.26,5.56,8.95,10.81,8.23,5.26-.71,8.95-5.55,8.23-10.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m384.71,70.15c-.47-3.45-3.65-5.87-7.1-5.4-3.45.47-5.87,3.64-5.4,7.1.47,3.45,3.65,5.87,7.1,5.4,3.45-.47,5.87-3.64,5.4-7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m521.01,121.25c-.15-1.14-1.2-1.94-2.34-1.78-1.14.15-1.94,1.2-1.78,2.34.15,1.14,1.2,1.94,2.34,1.78,1.14-.15,1.94-1.2,1.78-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m466.83,39.13c-.13-.93-.98-1.57-1.9-1.45-.93.13-1.57.98-1.45,1.9.13.93.98,1.57,1.9,1.45.93-.13,1.57-.98,1.45-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m358.54,38.7c-.13-.93-.98-1.57-1.9-1.45-.93.13-1.57.98-1.45,1.9.13.93.98,1.57,1.9,1.45.92-.13,1.57-.98,1.45-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m466.87,189.7c-.2-1.48-1.56-2.52-3.05-2.32-1.48.2-2.52,1.56-2.32,3.05.2,1.48,1.56,2.52,3.05,2.32s2.52-1.56,2.32-3.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m391.77,163.93c-.23-1.71-1.8-2.9-3.51-2.67-1.71.23-2.9,1.8-2.67,3.51.23,1.71,1.8,2.9,3.51,2.67,1.71-.23,2.9-1.8,2.67-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m339.03,46.75c-.26-1.91-2.02-3.25-3.93-2.99-1.91.26-3.25,2.02-2.99,3.93.26,1.91,2.02,3.25,3.93,2.99,1.91-.26,3.25-2.02,2.99-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m499.49,43.9c-.36-2.63-2.78-4.47-5.4-4.11-2.62.36-4.47,2.77-4.11,5.4.36,2.62,2.78,4.46,5.4,4.11,2.62-.36,4.47-2.77,4.11-5.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "444.59 205.08 452.37 199.35 443.35 195.89 437.62 188.12 434.16 197.14 426.38 202.87 435.4 206.33 441.14 214.11 444.59 205.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "512.69 154.22 516.64 151.31 512.06 149.55 509.15 145.61 507.4 150.19 503.45 153.09 508.03 154.85 510.94 158.79 512.69 154.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "388.8 11.17 392.75 8.26 388.17 6.51 385.26 2.56 383.51 7.14 379.56 10.05 384.14 11.8 387.05 15.75 388.8 11.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "338.67 168.64 342.62 165.73 338.04 163.98 335.13 160.04 333.38 164.61 329.43 167.52 334.01 169.28 336.92 173.22 338.67 168.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "510 84.27 513.95 81.36 509.37 79.61 506.46 75.66 504.71 80.24 500.76 83.15 505.34 84.9 508.25 88.85 510 84.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "424.37 109.61 443.92 103.75 423.12 100.41 415.42 78.16 413.92 101.65 396.02 108.76 415.17 110.86 421.82 136.18 424.37 109.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "326.86 83.47 338.81 79.89 326.09 77.84 321.39 64.24 320.47 78.61 309.52 82.95 321.23 84.23 325.3 99.72 326.86 83.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "457.07 147.42 465.39 144.93 456.54 143.51 453.27 134.05 452.63 144.04 445.01 147.06 453.16 147.95 455.99 158.73 457.07 147.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "413.24 40.85 420.18 38.77 412.8 37.59 410.07 29.7 409.53 38.03 403.18 40.55 409.98 41.3 412.33 50.28 413.24 40.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "373.73 199.7 380.67 197.62 373.29 196.43 370.56 188.54 370.02 196.88 363.67 199.4 370.47 200.14 372.82 209.13 373.73 199.7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWandWizard);
export default __webpack_public_path__ + "static/media/wand-Wizard.97407e0d.svg";
export { ForwardRef as ReactComponent };